export const translations = {
    'button.contactWithUsAndOpenModal.text': 'Skontaktuj się z motoconcierge'
};
